import { render, staticRenderFns } from "./Internet.vue?vue&type=template&id=8477ca70&"
import script from "./Internet.vue?vue&type=script&lang=js&"
export * from "./Internet.vue?vue&type=script&lang=js&"
import style0 from "./style.scss?vue&type=style&index=0&lang=scss&module=true&"
import style1 from "./Internet.vue?vue&type=style&index=1&lang=scss&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports